import styled from "styled-components";

export const Container = styled.section`
  .rankingSellerContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 15px 0;
    background-color: ${({ theme }) => theme.colors.secondary};
    padding: 15px;
    border-radius: 10px;
  }

  .rankingSellerInfo {
    display: flex;
    align-items: center;
  }
  .rankingSellerInfo > span {
    display: flex;
    align-items: center;
    margin-right: 15px;
    color: ${({ theme }) => theme.colors.black};
    width: 22px;
  }
  .rankingSellerNameCity {
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .rankingSellerName {
    font-size: 12px;
    font-weight: 700;
    text-transform: capitalize;
  }
  .rankingSellerCity {
    font-size: 9px;
    text-transform: capitalize;
  }
  .rankingSellerInfo > img {
    width: 45px;
    resize: both;

    height: 45px;
    border-radius: 100%;
    font-size: 11px;
  }
  @media (min-width: 800px) {
    .rankingSellerInfo > img {
      width: 60px;
      height: 60px;
      border-radius: 100%;
    }
    .rankingSellerNameCity {
      margin-left: 30px;
    }
    .rankingSellerName {
      font-size: 15px;
      font-weight: 700;
      text-transform: capitalize;
    }
    .rankingSellerCity {
      font-size: 11px;
      text-transform: capitalize;
      color: ${({ theme }) => theme.colors.black};
    }
  }
`;
